import React from 'react';
import { Icon } from 'merchant-portal-components';

const ChevronUpIcon = (props) => (
  <Icon className="fa fa-chevron-up" {...props} />
);

export default ChevronUpIcon;
